export enum UserRole {
  Admin = 'ADMIN',
  Accounting = 'ACCOUNTING',
  LimitedShiftCreator = 'LIMITED_SHIFT_CREATOR',
  ShiftCreator = 'SHIFT_CREATOR',
  Supervisor = 'SUPERVISOR',
  ViewOnly = 'VIEW_ONLY',
}

export const USER_ROLE_NAMES: { [K in UserRole]: string } = {
  [UserRole.Admin]: 'Admin',
  [UserRole.Accounting]: 'Accounting',
  [UserRole.LimitedShiftCreator]: 'Shift Creator',
  [UserRole.ShiftCreator]: 'Shift & Role Manager',
  [UserRole.Supervisor]: 'Supervisor',
  [UserRole.ViewOnly]: 'View Only',
}

export const USER_ROLES = Object.values(UserRole)

export const USER_ROLE_OPTIONS = USER_ROLES.map((value) => ({
  value,
  label: USER_ROLE_NAMES[value],
}))

// NOTE: Viewing / managing the following resources is considered part of
// viewing / managing shifts, so the appropriate shift permission is used
// to determine access to them: roles, locations, POCs.
export enum UserRolePermission {
  ViewShifts = 'VIEW_SHIFTS',
  ManageShifts = 'MANAGE_SHIFTS',
  ViewWorkers = 'VIEW_WORKERS',
  ManageWorkers = 'MANAGE_WORKERS',
  ViewTimesheets = 'VIEW_TIMESHEETS',
  ManageTimesheets = 'MANAGE_TIMESHEETS',
  ViewInvoices = 'VIEW_INVOICES',
  ManageInvoices = 'MANAGE_INVOICES',
  ViewCompanySettings = 'VIEW_COMPANY_SETTINGS',
  ManageCompanySettings = 'MANAGE_COMPANY_SETTINGS',
  ViewPaymentSettings = 'VIEW_PAYMENT_SETTINGS',
  ManagePaymentSettings = 'MANAGE_PAYMENT_SETTINGS',
  ViewUserRoles = 'VIEW_USER_ROLES',
  ManageUserRoles = 'MANAGE_USER_ROLES',
  ViewPay = 'VIEW_PAY',
  ManageShiftRoles = 'MANAGE_SHIFT_ROLES',
  ManageLocations = 'MANAGE_LOCATIONS',
  ViewAllMembers = 'VIEW_ALL_MEMBERS',
  ViewAllLocations = 'VIEW_ALL_LOCATIONS',
}

export interface UserRoleSetting {
  role: UserRole
  permissions: UserRolePermission[]
}
